module.exports = __webpack_public_path__ + "static/media/app-light-background.72cf2716.png";